module.exports = {
	"description": "Different kinds of rooms",
	"rooms": [
		"aerary",
		"aircraft cabin",
		"airport lounge",
		"alcove",
		"anatomical theatre",
		"anechoic chamber",
		"antechamber",
		"anteroom",
		"armory",
		"assembly room",
		"atelier",
		"attic",
		"auditorium",
		"backroom",
		"ballroom",
		"basement",
		"bathroom",
		"bedroom",
		"billiard room",
		"boardroom",
		"boiler room",
		"boudoir",
		"breakfast nook",
		"breezeway",
		"cabin",
		"cafeteria",
		"caldarium",
		"cellar",
		"changing room",
		"chapel",
		"classroom",
		"clean room",
		"cloakroom",
		"closet",
		"cold room",
		"common room",
		"computer lab",
		"conference room",
		"conservatory",
		"control room",
		"conversation pit",
		"corner office",
		"courtroom",
		"cry room",
		"darkroom",
		"den",
		"dining room",
		"dormitory",
		"drawing room",
		"dressing room",
		"electrical room",
		"emergency room",
		"engine room",
		"equipment room",
		"fallout shelter",
		"family room",
		"fitting room",
		"foyer",
		"game room",
		"garage",
		"guest room",
		"gym",
		"hotel room",
		"kitchen",
		"laundry room",
		"library",
		"living room",
		"lobby",
		"locker room",
		"loft",
		"lounge",
		"mailroom",
		"map room",
		"motel room",
		"mud room",
		"newsroom",
		"nursery",
		"office",
		"panic room",
		"pantry",
		"parlor",
		"playroom",
		"pool room",
		"print room",
		"rec room",
		"salon",
		"sauna",
		"schoolroom",
		"showroom",
		"sitting room",
		"staff room",
		"stockroom",
		"storm cellar",
		"studio",
		"study",
		"sunroom",
		"tearoom",
		"throne room",
		"transmission control room",
		"tv room",
		"utility room",
		"waiting room",
		"washroom",
		"water closet",
		"weight room",
		"wine cellar",
		"wiring closet",
		"workshop"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/architecture/rooms.json
 **/